<template>

    <b-container fluid>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(salvarDados)">

                <b-row class="m-0 mb-1 p-0 d-flex justify-content-center  ">

                    <b-col v-if="campoAtivo === true" cols="12" sm="6" xl="6"
                        class="d-flex align-items-center justify-content-start">
                        <span class="font-weight-bold h7">Buscar usuários</span>
                        <span class="ml-1 h7"><font-awesome-icon icon="magnifying-glass" /></span>
                    </b-col>
                </b-row>

                <b-row class="m-0 p-0 d-flex justify-content-center">

                    <b-col v-if="campoAtivo === true" cols="12" sm="12" xl="6">

                        <InputBuscaUsuarioUO @input="preencherCampos" @limpar="limparCampos" />

                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-center m-0">
                    <b-col v-if="campoAtivo === true" cols="12" sm="12" xl="12">
                        <hr>
                    </b-col>

                </b-row>
                <b-row class="d-flex justify-content-center m-0">

                    <b-col cols="12" sm="6" xl="6" class="m-0">
                        <default-form-validation-provider v-slot="defaultState" label="CPF:">
                            <b-form-input placeholder="Digite o cpf do usuário" v-model="contatoResponsavel.Cpf"
                                :state="defaultState.state" type="number"
                                :disabled="(campoAtivo === false) || (bloquearCampo === true)" />
                        </default-form-validation-provider>
                    </b-col>

                    <b-col cols="12" sm="6" xl="6" class="m-0">
                        <default-form-validation-provider v-slot="defaultState" label="Nome:">
                            <b-form-input placeholder="Digite o nome do usuário" :state="defaultState.state"
                                v-model="contatoResponsavel.Nome"
                                :disabled="(campoAtivo === false) || (bloquearCampo === true)" />
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="6" class="m-0">

                        <default-form-validation-provider label="Telefone" v-slot="defaultState">
                            <vue-tel-input v-model="contatoResponsavel.Fone" :onlyCountries="['br']" defaultCountry="br"
                                :validCharactersOnly="true" :autoDefaultCountry="false" :state="defaultState.state"
                                class="form-control" :props="vueTelOptions" :inputOptions="options" />
                        </default-form-validation-provider>

                        <!-- <default-form-validation-provider v-slot="defaultState" label="Fone:">
                            <b-form-input placeholder="Digite o telefone do usuário" :state="defaultState.state"
                                v-model="contatoResponsavel.Fone" :disabled="campoAtivo === false" />
                        </default-form-validation-provider> -->
                    </b-col>
                    <b-col cols="12" sm="6" xl="6" class="m-0">
                        <default-form-validation-provider v-slot="defaultState" label="Email:">
                            <b-form-input placeholder="Digite o email do usuário" :state="defaultState.state"
                                type="email" v-model="contatoResponsavel.Email" :disabled="campoAtivo === false" />
                        </default-form-validation-provider>
                    </b-col>

                    <b-col cols="12" sm="6" xl="6" class="m-0">

                    </b-col>
                    <b-col cols="12" sm="6" xl="6" class="m-0 d-flex justify-content-end">
                        <div class="d-flex align-items-right">
                            <b-button v-if="campoAtivo === true" size="sm" type="submit"
                                :disabled="contatoResponsavel.Cpf === '' || contatoResponsavel.Nome === '' || contatoResponsavel.Fone === '' || contatoResponsavel.Email === ''"
                                class="mt-3">Salvar</b-button>
                        </div>
                    </b-col>



                </b-row>
            </b-form>
        </validation-observer>
    </b-container>
</template>

<script lang="ts">
import { Component, Vue, Ref } from 'vue-property-decorator'
import { PropType } from "vue";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { store } from "@/store"
import { ContatosResponsavel } from '@/types/ug/uo/contato-responsavel';
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { ValidationObserver } from 'vee-validate';
import unidadeOrcamentariaService from '@/services/entregas/uo/unidadeOrcamentariaService';
import InputBuscaUsuarioUO from './InputBuscaUsuarioUO.vue';
import { UsuarioSumario } from '@/types/usuario-sumario';
const CompProps = Vue.extend({
    name: 'CardContatoResponsavel',
    props: {
        contato: {
            type: Object as PropType<ContatosResponsavel>,
            required: true
        },
        IdUnidade: {
            type: Number,
            required: true
        },
        campoAtivo: {
            type: Boolean,
            required: true
        }
    },
    components: { DefaultFormValidationProvider, ValidationObserver, InputBuscaUsuarioUO },
})

@Component
export default class CardContatoResponsavel extends mixins(UtilsTS, CompProps) {

    @Ref("validationobserver") validationobserver: InstanceType<typeof ValidationObserver>;

    //cópia dos dados do responsavel
    contatoResponsavel = new ContatosResponsavel()

    //Variável de controle
    bloquearCampo = false

    //ajustes do vue tel input
    options = { placeholder: "Digite o número de telefone do usuário" }
    mounted() {
        this.contatoResponsavel = new ContatosResponsavel(this.contato)
    }


    preencherCampos(usuario: UsuarioSumario) {
        if (usuario) {
            //console.log(usuario)
            this.bloquearCampo = true
            this.contatoResponsavel.Nome = usuario.Nome
            this.contatoResponsavel.Cpf = usuario.Cpf
            this.contatoResponsavel.Fone = usuario.NmTelefone
            this.contatoResponsavel.Email = usuario.Email
        }

    }

    limparCampos() {
        this.bloquearCampo = false
        this.contatoResponsavel.Nome = ""
        this.contatoResponsavel.Cpf = ""
        this.contatoResponsavel.Fone = ""
        this.contatoResponsavel.Email = ""
    }

    async salvarDados() {
        const regex = /^(\(\d{2}\))\s?(\d{4,5})-(\d{4})$/;
        if (this.validarRegex(this.contatoResponsavel.Fone, regex) == false) {
            this.$toast.error("Formato de número de telefone inválido")
            throw new Error("Formato de número de telefone inválido")
        }





        if (this.campoAtivo === true) {
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                this.$toast.error('Preencher campos obrigatórios (*)')
                console.error(this.validationobserver);
            }
            else {

                try {
                    store.blockScreen = true
                    const response = await unidadeOrcamentariaService.editarResponsavel(this.IdUnidade, this.contatoResponsavel.Cpf, this.contatoResponsavel.Nome, this.contatoResponsavel.Fone, this.contatoResponsavel.Email)
                    //console.log(response)
                    this.$toast.success("Dados atualizados com sucesso!")
                    this.$emit('dadosAtualizados');
                } catch (e: any) {
                    this.tratarError(e)
                } finally {
                    store.blockScreen = false
                }
            }
        } else {
            this.$toast.error("Não é possível alterar os dados de exercícios anteriores.")
        }
    }

    validarRegex = (valor, regex) => regex.test(valor);
}

</script>

<style scoped>
::v-deep div.vti__dropdown {
    display: none;
}

::v-deep input.vti__input::placeholder {
    opacity: 0.5;
}
</style>